"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _findIndex = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find-index"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _lastIndexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/last-index-of"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var PropTypes = require("prop-types");

var React = require("react"),
    ReactDOM = require("react-dom"),
    Spinner = require("../general/Spinner"),
    _ = require("underscore");
/**
 * @callback Batch~onGenerateHeading
 *
 * @param {object} data
 *    The data item from the batch for the current row.
 * @param {string} previousHeading
 *    The previous heading text generated from the last call to the generator.
 *
 * @returns {string|null}
 *    The generated section heading text or null if no heading should be added.
 */

/**
 * @class Batch
 * @memberof InfiniteScroll
 *
 * @param {string} [data-id="batch"]
 *    To define the base "data-id" value for the top-level HTML container.
 *
 * @param {Batch~onGenerateHeading} [onGenerateHeading]
 *    A heading generator function. If the result is anything but null, a new heading will be generated
 *    the content of which will be set to the result of the call.
 *
 * @private
 * @ignore
 */


var Batch = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Batch, _React$Component);

  var _super = _createSuper(Batch);

  function Batch() {
    (0, _classCallCheck2.default)(this, Batch);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Batch, [{
    key: "componentWillUpdate",
    value: function componentWillUpdate() {
      var container = ReactDOM.findDOMNode(this.refs.container);

      if (container) {
        this.containerHeight = ReactDOM.findDOMNode(this.refs.container).scrollHeight;
        this.containerWidth = ReactDOM.findDOMNode(this.refs.container).scrollWidth;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var visible = this.props.isVisible !== false;
      var style = {};
      var rows = null;
      var heading = this.props.prev && this.props.onGenerateHeading(_.last(this.props.prev));

      if (!visible) {
        style.height = this.containerHeight;
        style.width = this.containerWidth;
      } else {
        rows = [];

        for (var i = 0; i < this.props.data.length; i += 1) {
          var nextHeading = this.props.onGenerateHeading(this.props.data[i], heading);

          if (nextHeading !== null) {
            rows.push( /*#__PURE__*/React.createElement("div", {
              key: i
            }, /*#__PURE__*/React.createElement("div", {
              className: "item-head"
            }, nextHeading), React.cloneElement(this.props.contentType, this.props.data[i])));
            heading = nextHeading;
          } else {
            rows.push(React.cloneElement(this.props.contentType, _.defaults({
              key: i
            }, this.props.data[i])));
          }
        }
      }

      return /*#__PURE__*/React.createElement("div", {
        "data-id": this.props["data-id"],
        ref: "container",
        className: "batch",
        style: style
      }, rows);
    }
  }]);
  return Batch;
}(React.Component);
/**
* @typedef InfiniteScroll~BatchItem
* @desc A single batch item (e.g. &#123;id: _id, data: [_data_]&#125).
*
* @property {number} id
*    The item's identifier.
* @property {array<*>} data
*    The data for the batch item.
*/

/**
* @typedef InfiniteScroll~VisibleItem
* @desc The batch id and scroll offset of the top visible item.
*
* @property {number} batchId
*    The batch id of the top visible item.
* @property {number} itemIndex
*    The array index of the item within the batch of the top visible item.
*/

/**
* @typedef InfiniteScroll~initialItem
* @desc The batch index and item index of the initial item to display.
*
* @property {number} batchIndex
*    The array index of the batch in which the initial item is found within batches.
* @property {number} itemIndex
*    The array index of the item in the batch at batchIndex.
*/

/**
 * @callback InfiniteScroll~onScroll
 *
 * @param {InfiniteScroll~VisibleItem} visibleItem
 *    The new top visible item.
 */

/**
* @callback InfiniteScroll~onLoadPrev
*/

/**
* @callback InfiniteScroll~onLoadNext
*/

/**
 * @callback InfiniteScroll~onGenerateHeading
 *
 * @param {array<*>} data
 *    The array of data from the batch for the current row.
 * @param {string} previousHeading
 *    The previous heading text generated from the last call to the generator.
 *
 * @returns {string|null}
 *    The generated section heading text or null if no heading should be added.
 */

/**
 * @class InfiniteScroll
 * @desc An scrolling component which pages content in and out of the dom as their visibility changes.
 *    Content is passed as an array of batches which is a simple js object with an id and an array of rows.
 *
 * @param {string} [data-id="infinite-scroll"]
 *    To define the base "data-id" value for the top-level HTML container.
 * @param {string} [className]
 *    CSS classes to set on the top-level HTML container.
 *
 * @param {array<InfiniteScroll~BatchItem>} batches
 *    An array of InfiniteScroll~BatchItem objects.
 * @param {InfiniteScroll~initialItem} [initialItem]
 *    An object describing the batch index and item index of the first row to display.
 * @param {InfiniteScroll~onScroll} [onScroll]
 *    Callback to be triggered when the component is scrolled.
 *
 * @param {boolean} [hasPrev=false]
 *    Whether or not ther are more batches preceeding the first batch loaded.
 * @param {InfiniteScroll~onLoadPrev} [onLoadPrev]
 *    Callback to be triggered when the previous batch of data is fetched.
 *    Executed when the user scrolls to the top of the container.
 *
 * @param {boolean} [hasNext=false]
 *    Whether or not there are more batches following the last batch loaded.
 * @param {InfiniteScroll~onLoadNext} [onLoadNext]
 *    Callback to be triggered when the next batch of data is fetched.
 *    Executed when the user scrolls to the bottom of the container.
 *
 * @param {Component} contentType
 *    A ReactJS component representing the row type.
 *
 * @param {InfiniteScroll~onGenerateHeading} [onGenerateHeading]
 *    A heading generator function. If the result is anything but null, a new heading will be generated
 *    the content of which will be set to the result of the call.
 *
 * @param {number} [height]
 *    The height of the container. Required when not attached to the window.
 * @param {number} [minHeight]
 *    Minimum height for the container (when not attached to window).
 * @param {bool} [attachToWindow=false]
 *    If true, the component will attach to the window instead of creating a scrolling container.
 *
 * @example
 *   var batches=[{id: 1, data: ['some', 'data', 'here']}...];
 *   <InfiniteScroll onLoadNext={this.onLoadNext} hasNext={true} hasPrev={false} batches={batches} contentType={MyRow} />
 */


(0, _defineProperty2.default)(Batch, "displayName", "Batch");
(0, _defineProperty2.default)(Batch, "propTypes", {
  "data-id": PropTypes.string
});
(0, _defineProperty2.default)(Batch, "defaultProps", {
  "data-id": "batch",
  onGenerateHeading: _.noop
});

var InfiniteScroll = /*#__PURE__*/function (_React$Component2) {
  (0, _inherits2.default)(InfiniteScroll, _React$Component2);

  var _super2 = _createSuper(InfiniteScroll);

  function InfiniteScroll(props) {
    var _this;

    (0, _classCallCheck2.default)(this, InfiniteScroll);
    _this = _super2.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_padVisibility", function (visibility) {
      // Pad visibility with a batch before & after the batches currently visible in the container viewport
      // to fix Chrome & Firefox getBoundingClientRect() timing issue when scrolling returning incorrect
      // element calculations boxes resulting in buggy scrolling: UIP-1179, UIP-1195
      var firstVisible = (0, _indexOf.default)(visibility).call(visibility, true);
      var lastVisible = (0, _lastIndexOf.default)(visibility).call(visibility, true);

      if (firstVisible !== -1 && firstVisible !== 0) {
        visibility[firstVisible - 1] = true;
      }

      if (lastVisible !== -1 && lastVisible !== visibility.length - 1) {
        visibility[lastVisible + 1] = true;
      }

      return visibility;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getBatchVisibility", function () {
      var _context, _context2;

      return _this._padVisibility((0, _map.default)(_context = _this.props.batches).call(_context, (0, _bind.default)(_context2 = function _context2(e, i) {
        return this._isBatchVisible(i);
      }).call(_context2, (0, _assertThisInitialized2.default)(_this))));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_rectIntersect", function (r1, r2) {
      return !(r2.left > r1.right || r2.right < r1.left || r2.top > r1.bottom || r2.bottom < r1.top);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_isBatchVisible", function (batchIndex) {
      var batch = _this._getBatchNode(batchIndex);

      return !batch || _this._rectIntersect(batch.getBoundingClientRect(), _this._getContainerBounds());
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getFirstVisibleItem", function () {
      var containerOffset = _this._getContainerBounds().top;

      for (var i = 0; i < _this.props.batches.length; i += 1) {
        var node = _this._getBatchNode(i);

        var bounds = node.getBoundingClientRect();

        if (bounds.bottom >= containerOffset) {
          for (var j = 0; j < node.childNodes.length; j += 1) {
            if (node.childNodes[j].getBoundingClientRect().bottom >= containerOffset) {
              return {
                batchId: _this.props.batches[i].id,
                itemIndex: j
              };
            }
          }
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_scrollContainerBy", function (y) {
      if (_this.props.attachToWindow) {
        window.scrollTo(0, window.scrollY + y);
      } else {
        ReactDOM.findDOMNode(_this.refs.container).scrollTop += y;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getContainerBounds", function () {
      return _this.props.attachToWindow ? {
        top: 0,
        bottom: window.innerHeight
      } : ReactDOM.findDOMNode(_this.refs.container).getBoundingClientRect();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_didScrollToBottom", function () {
      var containerBounds = _this._getContainerBounds();

      return _this.props.hasNext && ReactDOM.findDOMNode(_this.refs.spinnerNext).getBoundingClientRect().top <= containerBounds.bottom;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_didScrollToTop", function () {
      var containerBounds = _this._getContainerBounds();

      return _this.props.hasPrev && ReactDOM.findDOMNode(_this.refs.spinnerPrev).getBoundingClientRect().bottom >= containerBounds.top;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleScroll", function (e) {
      //dont handle scrolls before there's any data
      if (!_this.batchRange) {
        return;
      }

      if (!_.isEqual(_this._getBatchVisibility(), _this.visibilityArray)) {
        _this.forceUpdate();
      }

      if (_this._didScrollToTop() && !_this._prepending) {
        if (_this.props.onLoadPrev) {
          _this._prepending = true;

          _this.props.onLoadPrev();
        }
      }

      if (_this._didScrollToBottom() && !_this._appending) {
        if (_this.props.onLoadNext) {
          _this._appending = true;

          _this.props.onLoadNext();
        }
      }

      if (_this.props.onScroll) {
        _this.props.onScroll(_this._getFirstVisibleItem(), e);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getBatchNode", function (batchIndex) {
      return ReactDOM.findDOMNode(_this.refs["batch" + batchIndex]);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "jumpToItem", function (batchIndex, itemIndex, scrollIfOutOfView) {
      var batch = _this._getBatchNode(batchIndex);

      if (batch && batch.childNodes.length > itemIndex) {
        var containerBounds = _this._getContainerBounds();

        if (!_this.visibilityArray[batchIndex]) {
          var _context3;

          var batchBounds = batch.getBoundingClientRect();

          _this._scrollContainerBy(batchBounds.top - containerBounds.top);

          (0, _setTimeout2.default)((0, _bind.default)(_context3 = _this.jumpToItem).call(_context3, (0, _assertThisInitialized2.default)(_this), batchIndex, itemIndex), 100);
          return;
        }

        var itemBounds = batch.childNodes[itemIndex].getBoundingClientRect();

        if (!scrollIfOutOfView || itemBounds.bottom > containerBounds.bottom || itemBounds.top < containerBounds.top) {
          _this._scrollContainerBy(itemBounds.top - containerBounds.top);
        } //get the updated client rect


        itemBounds = batch.childNodes[itemIndex].getBoundingClientRect();
        return itemBounds.bottom <= containerBounds.bottom && itemBounds.top >= containerBounds.top;
      } else {
        return false;
      }
    });
    _this.visibilityArray = _this._getBatchVisibility();
    _this.inited = false;

    if (props.attachToWindow) {
      window.addEventListener("scroll", _this._handleScroll);
    }

    return _this;
  }

  (0, _createClass2.default)(InfiniteScroll, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.attachToWindow) {
        window.removeEventListener("scroll", this._handleScroll);
      }
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate() {
      this.visibilityArray = this._getBatchVisibility();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.componentDidUpdate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.batches.length === 0) {
        return;
      }

      var newRange = {
        start: this.props.batches[0].id,
        end: this.props.batches[this.props.batches.length - 1].id
      }; //after loading the first batch of data hide the prevSpinner

      if (!this.batchRange && this.props.hasPrev) {
        this.jumpToItem(0, 0);
      } //when a new batch is prepended, the container's scrollTop should be adjusted by the height of the new batch
      //so that the content in view doesnt change


      if (this.batchRange && newRange.start !== this.batchRange.start) {
        this._scrollContainerBy(ReactDOM.findDOMNode(this.refs.batch0).clientHeight);

        this._prepending = false; // clear prepending state when new batch is prepended
      } //after the first render with data, jump to the offset specified in the props


      if (!this.inited && this.props.batches.length > 0 && this.props.initialItem) {
        var batchIndex = this.props.initialItem.batchIndex;

        if (typeof this.props.initialItem.batchId !== "undefined") {
          batchIndex = (0, _findIndex.default)(_).call(_, this.props.batches, {
            id: this.props.initialItem.batchId
          });
        }

        if (batchIndex !== -1) {
          this.inited = this.jumpToItem(batchIndex, this.props.initialItem.itemIndex);
        }
      } // clear appending state when new batch is appended


      if (this.batchRange && newRange.end !== this.batchRange.end) {
        this._appending = false;
      }

      this.batchRange = newRange;
    }
  }, {
    key: "render",
    value: function render() {
      var _context4, _context5;

      if (this.props.batches.length === 0) {
        return /*#__PURE__*/React.createElement("div", {
          ref: "container"
        }, this.props.children);
      }

      var style = null,
          onScroll = null,
          ref = null;

      if (!this.props.attachToWindow) {
        style = _.defaults({
          overflow: "auto",
          height: "100%"
        }, _.pick(this.props, "minHeight", "height"));
        onScroll = this._handleScroll;
        ref = "container";
      }

      return /*#__PURE__*/React.createElement("div", {
        "data-id": this.props["data-id"],
        className: this.props.className,
        style: style,
        onScroll: onScroll,
        ref: ref
      }, this.props.hasPrev ? /*#__PURE__*/React.createElement("span", {
        ref: "spinnerPrev"
      }, /*#__PURE__*/React.createElement(Spinner, {
        show: true
      })) : null, (0, _map.default)(_context4 = this.props.batches).call(_context4, (0, _bind.default)(_context5 = function _context5(b, i) {
        return /*#__PURE__*/React.createElement(Batch, {
          prev: i > 0 ? this.props.batches[i - 1].data : null,
          data: b.data,
          ref: "batch" + i,
          key: b.id,
          id: b.id,
          onGenerateHeading: this.props.onGenerateHeading,
          contentType: this.props.contentType,
          isVisible: this.visibilityArray[i]
        });
      }).call(_context5, this)), this.props.hasNext ? /*#__PURE__*/React.createElement("span", {
        ref: "spinnerNext"
      }, /*#__PURE__*/React.createElement(Spinner, {
        show: true
      })) : null);
    }
  }]);
  return InfiniteScroll;
}(React.Component);

(0, _defineProperty2.default)(InfiniteScroll, "displayName", "InfiniteScroll");
(0, _defineProperty2.default)(InfiniteScroll, "propTypes", {
  "data-id": PropTypes.string,
  batches: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    data: PropTypes.array
  })).isRequired,
  initalItem: PropTypes.object,
  onScroll: PropTypes.func,
  hasPrev: PropTypes.bool,
  onLoadPrev: PropTypes.func.isRequired,
  hasNext: PropTypes.bool,
  onLoadNext: PropTypes.func.isRequired,
  contentType: PropTypes.object,
  onGenerateHeading: PropTypes.func,
  height: PropTypes.number,
  minHeight: PropTypes.number,
  attachToWindow: PropTypes.bool,
  children: PropTypes.node
});
(0, _defineProperty2.default)(InfiniteScroll, "defaultProps", {
  "data-id": "infinite-scroll",
  hasPrev: false,
  hasNext: false,
  attachToWindow: false
});
InfiniteScroll.Batch = Batch;
module.exports = InfiniteScroll;